import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  MenuItem,
  Select,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
  TableFooter,
  TablePagination,
  Icon,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetByChapterIdQuery, useDeleteQuestionMutation, useReorderQuestionsMutation } from "App/services/QuestionServiceApi";
import Loading from "components/Loading";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import QuestionFormDialogue from "./components/questionFormDialogue";
import NotesFormDialogue from "./components/NotesFormDialogue";
import EditQuestionFormDialogue from "./components/EditquestionFormDialogue";
import TablePaginationActions from "layouts/category/components/TablePagination";
import parse from "html-react-parser";
import EditNotesFormDialogue from "./components/EditNotesFormDialogue";
import useReorder from "components/Reorder/useReorder";
import ReorderableTableRow, { DragColumnHeader } from "components/Reorder/ReorderableTableRow";
import useFeatureEnabled from "components/FeatureToggle/useFeatureEnabled";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.min.css";

const useAllQuestionData = (data) => {
  const byCatIdQuery = useGetByChapterIdQuery(data, { refetchOnFocus: false });

  const [result, setResult] = useState({
    data: null,
    isLoading: true,
    isError: false,
    error: null,
    refetch: () => {},
  });

  useEffect(() => {
    if (data !== null) {
      setResult({
        data: byCatIdQuery.data,
        isLoading: byCatIdQuery.isLoading,
        isError: byCatIdQuery.isError,
        error: byCatIdQuery.error,
        refetch: byCatIdQuery.refetch,
      });
    }
  }, [data, byCatIdQuery]);

  return result;
};

function Question() {
  const [open, setOpen] = React.useState(false);
  const [page, setPage] = useState(0);
  const [dialogType, setDialogType] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const dragDropEnabled = useFeatureEnabled("drag_drop_reorder");
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state || {};

  const { data: questions, isLoading, isFetching, isError, error, refetch } = useAllQuestionData(data.data);
  const [deleteQuestion] = useDeleteQuestionMutation();
  const [reorderQuestions] = useReorderQuestionsMutation();

  const { ordered: sortedQuestions, handleDragStart, handleDragOver, handleDrop } = useReorder(
    questions,
    (ids) => reorderQuestions({ chapterId: data.data, orderedIds: ids }).catch((err) => console.log(err))
  );

  if (isLoading || isFetching) {
    return <Loading />;
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteQuestion = async () => {
    try {
      await deleteQuestion(deleteId).unwrap();
      setDeleteDialogOpen(false);
      setDeleteId(null);
      if (questions.length === 1) {
        window.location.reload();
      } else {
        refetch();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteConfirmation = (questionId) => {
    // console.log("questionId ===> ", questionId)
    setDeleteId(questionId);
    setDeleteDialogOpen(true);
  };

  const handleDialogOpen = (type) => {
    setDialogType(type);
    setOpen(true);
  };

  const handleDialogClose = () => {
    setOpen(false);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setDeleteId(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return questions ? (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                position="sticky"      
                top={0}    
              >
                <MDTypography variant="h6" color="white">
                  Questions
                </MDTypography>

                <Select
                  value=""
                  onChange={(e) => handleDialogOpen(e.target.value)}
                  displayEmpty
                  renderValue={() => "Add"}
                  variant="outlined"
                  size="medium"
                  sx={{
                    bgcolor: "#ffffff",
                    paddingX: "20px",
                    paddingY: "10px",
                    borderRadius: "10px",
                    color: "7B80A7",
                    cursor: "pointer",
                  }}
                >
                  <MenuItem value="question">Add Question</MenuItem>
                  <MenuItem value="note">Add Note</MenuItem>
                </Select>
              </MDBox>
              <TableContainer style={{ maxHeight: "400px", overflow: "auto" }} >
                <Table stickyHeader>
                  <TableBody >
                    {(rowsPerPage > 0
                      ? sortedQuestions &&
                        sortedQuestions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : sortedQuestions
                    ).map((question) => (
                      <ReorderableTableRow
                        key={question.id}
                        id={question.id}
                        dragEnabled={dragDropEnabled}
                        onDragStart={handleDragStart}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        sx={{ borderBottom: "1px solid black" }}
                      >
                        {question.notes ? (
                          <>
                            <TableCell
                              sx={{
                                display: "flex",
                                alignItems: "center", 
                              }}
                            >
                              <h3 style={{ paddingRight: "35px" }}>Notes : </h3>
                            </TableCell>
                            <TableCell
                              sx={{
                                display: "flex",
                                alignItems: "flex-start", 
                                justifyContent: "start",
                                paddingRight: 10,
                                paddingLeft: 20,
                                overflowY: "auto", 
                                overflowX: "auto",
                                height: 120,
                                width: 1000,
                                borderBottom:"1px solid black"
                              }}
                            >
                              {parse(question.notes)}
                            </TableCell>
                             <TableRow sx={{ display: "flex", alignItems: "center", paddingX: 4 }}>
                              <h4>Video Link : </h4>  <span style={{fontSize:16, paddingLeft:8}}>{question.video_link}</span>
                            </TableRow>
                            
                            <TableCell sx={{ textAlign: "right", paddingRight: 17 }}>
                              <Tooltip title="Edit">
                                <span>
                                  <EditNotesFormDialogue question={question} />
                                </span>
                              </Tooltip>
                              <Tooltip title="Delete">
                                <IconButton
                                  aria-label="delete"
                                  onClick={() => handleDeleteConfirmation(question.id)}
                                >
                                  <Icon>delete</Icon>
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </>
                        ) : (
                          <>
                            <TableRow
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                paddingX: 4,
                                paddingTop: 5,
                                
                              }}
                            >
                              <h4>Question : </h4>
                            </TableRow>
                            <TableRow
                              sx={{
                                display: "flex",
                                alignItems: "flex-start", 
                                justifyContent: "start",
                                paddingRight: 10,
                                paddingLeft: 20,
                                overflowY: "auto", 
                                overflowX: "auto",
                                height: 120,
                                width: 1000,
                              }}
                            >
                              {parse(question.que)}
                            </TableRow>
                            <TableRow sx={{ display: "flex", alignItems: "center", paddingX: 4 }}>
                              <h4>Answer : </h4>
                            </TableRow>
                            <TableRow
                              sx={{
                                display: "flex",
                                alignItems: "flex-start", 
                                justifyContent: "start",
                                paddingRight: 10,
                                paddingLeft: 20,
                                overflowY: "auto", 
                                overflowX: "auto",
                                height: 120,
                                width: 1000,
                                
                              }}
                            >
                              {parse(question.answer)}
                            </TableRow>
                            <TableRow sx={{ display: "flex", alignItems: "center", paddingX: 4 }}>
                              <h4>Video Link :</h4>
                            </TableRow>
                            <TableRow
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                paddingRight: 10,
                                paddingLeft: 20,
                                borderBottom:"1px solid black"
                              }}
                            >
                              {question.video_link}
                            </TableRow>
                         
                            
                            <TableCell sx={{ textAlign: "right", paddingRight: 17 }}>
                              <Tooltip title="Edit">
                                <span>
                                  <EditQuestionFormDialogue question={question} />
                                </span>
                              </Tooltip>
                              <Tooltip title="Delete">
                                <IconButton
                                  aria-label="delete"
                                  onClick={() => handleDeleteConfirmation(question.id)}
                                >
                                  <Icon>delete</Icon>
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </>
                        )}

                      </ReorderableTableRow>
                      
                    ))}
                  </TableBody>

                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                        colSpan={dragDropEnabled ? 5 : 4}
                        count={sortedQuestions ? sortedQuestions.length : 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: {
                            "aria-label": "rows per page",
                          },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                        sx={{
                          position: "sticky",
                          bottom: 0,
                          backgroundColor:"whitesmoke",
                          zIndex: 1,
                        }}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {dialogType === "question" && (
        <QuestionFormDialogue open={open} onClose={handleDialogClose} />
      )}
      {dialogType === "note" && <NotesFormDialogue open={open} onClose={handleDialogClose} />}

      <Dialog open={deleteDialogOpen} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete this question?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteQuestion} color="primary" style={{ color: "red" }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  ) : (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                position="sticky"
                top={0}
                zIndex={1}
              >
                <MDTypography variant="h6" color="white">
                  Questions
                </MDTypography>

                <Select
                  value=""
                  onChange={(e) => handleDialogOpen(e.target.value)}
                  displayEmpty
                  renderValue={() => "Add"}
                  variant="outlined"
                  size="medium"
                  sx={{
                    bgcolor: "#ffffff",
                    paddingX: "20px",
                    paddingY: "10px",
                    borderRadius: "10px",
                    color: "7B80A7",
                    cursor: "pointer",
                  }}
                >
                  <MenuItem value="question">Add Question</MenuItem>
                  <MenuItem value="note">Add Note</MenuItem>
                </Select>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {dialogType === "question" && (
        <QuestionFormDialogue open={open} onClose={handleDialogClose} />
      )}
      {dialogType === "note" && <NotesFormDialogue open={open} onClose={handleDialogClose} />}
    </DashboardLayout>
  );
}

export default Question;
